// gastos.repository.js

import { supabase } from '../../../infra_/supabase/supabaseClient.js'; 

export const gastosCategoriaRepository = {
  async listar(filtros = {}) {
    let query = supabase
      .from("gastos_categoria")
      .select("*")
      .order("id_categoria", { ascending: false })
      .limit(100);
    
    if (filtros.activa) {
      query = query.eq("activa", filtros.activa);
    }

    const { data, error } = await query;
    if (error) throw error;

    return data;
  },
};